var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "136,246 175.8,233 200.4,267 200.4,225 240.3,212 200.4,199.1 200.4,157.1 175.8,191.1 136,178.1  160.7,212 136,246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "201.1,115.6 288.7,212.1 201.1,308.6 276.3,308.6 364,212.1 276.3,115.6 201.1,115.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.3,349c3.4,0,6.9,1.7,9.2,4.5l0.8,1l10.7-7.3l-1-1.2c-4.7-5.9-11.9-9.3-19.7-9.3 c-13.7,0-24.9,10.7-24.9,23.8c0,13.1,11.2,23.8,24.9,23.8c7.7,0,14.9-3.3,19.6-9.2l1-1.2l-10.7-7.4l-0.8,1 c-2.3,2.8-5.6,4.4-9.1,4.4c-6.3,0-11.7-5.3-11.7-11.5C63.6,354.2,68.9,349,75.3,349L75.3,349z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "190.2,363.2 170.8,337.9 158.5,337.9 158.5,382.7 170.5,382.7 170.5,357.6 188.5,382.7 202.2,382.7  202.2,337.9 190.2,337.9 190.2,363.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.2,369.8L236.2,369.8c0,0.4-0.5,0.4-0.7,0.4c-0.2,0-0.6,0-0.7-0.5l-10-31.8h-13.7l14.6,44.8h19.6 l14.6-44.8h-13.7L236.2,369.8L236.2,369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.4,354.7h-10.5v-4.8h10.5c1.5,0,2.6,1,2.6,2.4C342.1,353.7,340.9,354.7,339.4,354.7L339.4,354.7z  M354.6,351.2c-0.6-7.5-7.1-13.2-14.8-13.2h-22.9v44.8h12v-16.1h5.4c0.5,0,1,0.1,1.3,0.5l7.7,15.6h13.5l-9.3-18.3 C352.3,361.7,355,356.7,354.6,351.2L354.6,351.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "449.6,349.9 449.6,337.9 413.7,337.9 413.7,382.7 449.6,382.7 449.6,370.8 425.7,370.8 425.7,365.4  447.2,365.4 447.2,354.7 425.7,354.7 425.7,349.9 449.6,349.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.7,354.8c-6.4-1.5-8.2-2.4-8.2-4.5v-0.1c0-1.7,1.3-3,4.4-3c4.1,0,7.5,1.3,12,4l7.2-8.5 c-5-4-11-6.1-18.9-6.1c-11.1,0-17.8,6.2-17.8,14.8v0.1c0,9.5,7.8,12.3,17.7,14.5c6.3,1.5,8,2.5,8,4.4v0.1c0,2-2.2,3.2-5.7,3.2 c-5.3,0-10.6-1.9-15.2-5.6l-7.2,8.5c5.7,5.1,13.9,7.7,22.1,7.7c11.2,0,19.1-5.6,19.1-15.1v-0.1 C404.2,360.6,397.3,357.1,386.7,354.8L386.7,354.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125,371.8c-6.3,0-11.4-5.1-11.4-11.4c0-6.3,5.1-11.4,11.4-11.4c6.3,0,11.4,5.1,11.4,11.4 C136.4,366.7,131.3,371.8,125,371.8L125,371.8z M125,336.6c-13.4,0-24.2,10.7-24.2,23.8c0,13.1,10.9,23.8,24.2,23.8 c13.4,0,24.2-10.7,24.2-23.8C149.2,347.3,138.4,336.6,125,336.6L125,336.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "268.5,382.7 304.4,382.7 304.4,370.8 280.5,370.8 280.5,365.4 302,365.4 302,354.7 280.5,354.7  280.5,349.9 304.4,349.9 304.4,337.9 268.5,337.9 268.5,382.7  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverse);
export default __webpack_public_path__ + "static/media/converse.3329f6d4740b309a1ca30154d29d57e9.svg";
export { ForwardRef as ReactComponent };